import { ComponentPropsWithoutRef } from "react";
import * as styles from "./SectionBlockTextColumns.css";
import {
  SectionBlockTextColumns as ISectionBlockTextColumns,
  Link,
} from "~/sanity/types";
import Grid from "~/components/globals/Grid";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";

export type SectionBlockTextColumnsProps = ComponentPropsWithoutRef<"div"> & {
  data: ISectionBlockTextColumns;
};

export const SectionBlockTextColumns = ({
  data,
  ...props
}: SectionBlockTextColumnsProps) => {
  const { title, subtitle, featuredText, textColumn1, textColumn2, links } =
    data;

  const layout = textColumn2 ? "block" : "inline";

  return (
    <section>
      <Grid {...props} className={styles.wrapper}>
        <div className={styles.headingContainer({ layout: layout })}>
          <div className={styles.headingWrapper}>
            <Heading as="h2" size="h3" className={styles.subtitle}>
              {subtitle}
            </Heading>
            <Heading
              as="h3"
              size="h1"
              uppercase
              className={styles.heading}
              bold
            >
              {title}
            </Heading>
            {featuredText && (
              <PortableText blocks={featuredText as IPortableText} />
            )}
          </div>
          {layout == "inline" && (
            <div className={styles.divider({ layout: layout })}></div>
          )}
        </div>

        <div className={styles.textContainer({ layout: layout })}>
          <div className={styles.textWrapper}>
            {textColumn1 && (
              <div className={styles.text({ layout: layout, column: 1 })}>
                <PortableText blocks={textColumn1 as IPortableText} />
              </div>
            )}
            {textColumn2 && (
              <div className={styles.text({ layout: layout, column: 2 })}>
                {layout == "block" && (
                  <div className={styles.divider({ layout: layout })}></div>
                )}
                <PortableText blocks={textColumn2 as IPortableText} />
              </div>
            )}
          </div>
          {links && (
            <div className={styles.linksContainer({ layout: layout })}>
              {links.map((link: Link, index) => (
                <ButtonLink
                  key={index}
                  link={link}
                  theme="dark"
                  isPrimary={false}
                  icons={{ iconPrimary: <ArrowOutward /> }}
                >
                  {link.text}
                </ButtonLink>
              ))}
            </div>
          )}
        </div>
      </Grid>
    </section>
  );
};
